let elements = {
  mainImage: {
    imagePath: 'games/page019_game1/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  icons: {
    negative: 'games/page019_game1/img/t.png',
    positive: 'games/page019_game1/img/f.png',
  },
  withoutCheck: false,
  maxLength: 1,
  audio: {
    negative: 'games/page019_game1/audio/f.mp3',
    positive: 'games/page019_game1/audio/t.mp3',
  },
  pick: 10,
  questions: [
    {
      src: 'games/page019_game1/img/foka.jpg',
      correct: 'f',
      width: 730,
    },
    {
      src: 'games/page019_game1/img/gitara.jpg',
      correct: 'g',
      width: 420,
    },
    {
      src: 'games/page019_game1/img/hulajnoga.jpg',
      correct: 'h',
      width: 357,
    },
    {
      src: 'games/page019_game1/img/igla.jpg',
      correct: 'i',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/lampa.jpg',
      correct: 'l',
      width: 329,
    },
    {
      src: 'games/page019_game1/img/kot.jpg',
      correct: 'k',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/mrowka.jpg',
      correct: 'm',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/nozyczki.jpg',
      correct: 'n',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/okulary.jpg',
      correct: 'o',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/papuga.jpg',
      correct: 'p',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/rak.jpg',
      correct: 'r',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/slon.jpg',
      correct: 's',
      width: 370,
    },
    {
      src: 'games/page019_game1/img/tulipan.jpg',
      correct: 't',
      width: 100,
    },
    {
      src: 'games/page019_game1/img/ul.jpg',
      correct: 'u',
      width: 600,
    },
    {
      src: 'games/page019_game1/img/waz.jpg',
      correct: 'w',
      width: 500,
    },
    {
      src: 'games/page019_game1/img/zegar.jpg',
      correct: 'z',
      width: 500,
    },
  ],
};

export default elements;
